export default __webpack_public_path__ + "static/media/Publish.767034cf.png";